export function pad(v: number) {
  return v.toString().padStart(2, "0");
}
